import billingModule from '../../billing.module';
import template from './billingGuest.component.html';
import style from './billingGuest.component.css';

export default billingModule.component('billingGuest', {
    template,
    style,
    controller: BillingGuestComponent
});

function BillingGuestComponent(
    guestAccessService,
    asNotifier,
    textResources,
    asLoadingMask,
    $window,
    $sessionStorage,
    sessionStorageConstants,
    $location,
    $scope
) {
    var billingOverviewUrl = '/#!/billing/overview';
    var baseUrl = '/';
    var vm = this;

    vm.$onInit = () => {
        $scope.$on('$locationChangeStart', function($event, next, current) {
            if (current.split('?')[0] == next.split('?')[0]) {
                vm.errorMessage = '';
                vm.render();
            }
        });
        vm.render();
    };

    vm.render = () => {
        vm.submitButtonText = textResources.billingGuestSubmitButtonText;

        tryResumeSession();

        asLoadingMask.show();

        var queryStringData = $location.search();

        guestAccessService.getLoginForm(queryStringData).then(
            form => {
                vm.form = form;

                var fieldCount = form.items.length;
                var fieldWithValueCount = form.items.filter(
                    x => x.model != null
                ).length;

                if (fieldCount == fieldWithValueCount) {
                    login(form.items).finally(() => asLoadingMask.hide());
                    return;
                }

                asLoadingMask.hide();
            },
            () => {
                asNotifier.error(textResources.configurationNotLoaded);
                asLoadingMask.hide();
            }
        );
    };

    vm.onSubmit = () => {
        asLoadingMask.show();
        login(vm.form.items).finally(() => asLoadingMask.hide());
    };

    vm.redirect = () => {
        $window.location.href = baseUrl;
    };

    function tryResumeSession() {
        var tokenBilling =
            $sessionStorage[sessionStorageConstants.tokenBilling];

        var hasExpired = () => new Date(tokenBilling.expiresOn) < Date.now();

        if (tokenBilling && !hasExpired()) {
            $window.location.href = billingOverviewUrl;
        }
    }

    function login(formItems) {
        return guestAccessService.login(formItems).then(
            () => {
                vm.errorMessage = '';
                $window.location.href = billingOverviewUrl;
            },
            data => {
                data = data || {};
                data.error = data.error || {};

                vm.errorMessage =
                    data.error.message || 'Invalid login information.';
            }
        );
    }
}



// WEBPACK FOOTER //
// ./modules/billing/components/billing-guest/billingGuest.component.js